import { useState, useEffect } from "react";

export const useSingleTab = (cookieName = "admission_tab") => {
  const [isSingleTab, setIsSingleTab] = useState(true);

  useEffect(() => {
    let tabId = sessionStorage.getItem("tabId") ?? '';

    if (!tabId) {
      tabId = Date.now().toString();
      sessionStorage.setItem("tabId", tabId);
    }

    const getCookie = (name: string): string | undefined => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop()?.split(";").shift();
    };

    const setCookie = (name: string, value: string, days: number) => {
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = `${name}=${value}; expires=${expires}; path=/`;
    };

    const removeCookie = (name: string) => {
      document.cookie = `${name}=; Max-Age=-99999999; path=/`;
    };
    const checkSingleTab = () => {
      const currentTabId = getCookie(cookieName) ??  localStorage.getItem(cookieName);
      if (!currentTabId) {
        setCookie(cookieName, tabId, 1);
        localStorage.setItem(cookieName, tabId); 
        setIsSingleTab(true);
      } else if (currentTabId === tabId?.toString()) {
        setIsSingleTab(true);
      } else {
        setIsSingleTab(false);
      }
    };

    checkSingleTab();

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkSingleTab();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    const handleBeforeUnload = () => {
      if (getCookie(cookieName) === tabId) {
        removeCookie(cookieName);
        sessionStorage.removeItem("tabId");
        localStorage.removeItem(cookieName);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      if (getCookie(cookieName) === tabId?.toString()) {
        removeCookie(cookieName);
        sessionStorage.removeItem("tabId");
        localStorage.removeItem(cookieName);
      }
    };
  }, [cookieName]);

  return { isSingleTab };
};
